import React from 'react';

import styles from './styles';

const Landing = () => (
  <div style={styles.container}>
    <h2>Busca textual em uma ampla base indexada de documentos governamentais</h2>
  </div>
);

export default Landing;



// WEBPACK FOOTER //
// ./src/components/Landing/Landing.js